import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import edgeMarketsState from './state';
export const edgeMarketsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => edgeMarketsState);
    },
    initialState: edgeMarketsState,
    name: 'edgeMarkets',
    reducers: {
        errorReceiveAllEdgeMarkets: {
            prepare: edgeMarkets => {
                return {
                    payload: {
                        edgeMarkets
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeMarkets } = action.payload;
                state.edgeMarkets = edgeMarkets;
                state.requestingEdgeMarkets = false;
            }
        },
        errorReceiveEdgeMarkets: state => {
            state.edgeMarkets = undefined;
            state.requestingEdgeMarkets = false;
        },
        errorReceiveEdgeMarketsForOrg: {
            prepare: edgeMarkets => {
                return {
                    payload: {
                        edgeMarkets
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeMarkets } = action.payload;
                state.edgeMarkets = edgeMarkets;
                state.requestingEdgeMarkets = false;
            }
        },
        failedReceiveEdgeMarkets: state => {
            state.edgeMarkets = undefined;
            state.requestingEdgeMarkets = false;
        },
        receiveEdgeMarkets: {
            prepare: edgeMarkets => {
                return {
                    payload: {
                        edgeMarkets
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeMarkets } = action.payload;
                state.edgeMarkets = edgeMarkets;
                state.requestingEdgeMarkets = false;
            }
        },
        requestEdgeMarkets: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingEdgeMarkets = true;
            }
        },
        resetEdgeMarkets: () => edgeMarketsState
    }
});
export const { errorReceiveAllEdgeMarkets, errorReceiveEdgeMarkets, errorReceiveEdgeMarketsForOrg, failedReceiveEdgeMarkets, receiveEdgeMarkets, requestEdgeMarkets, resetEdgeMarkets } = edgeMarketsSlice.actions;
export default edgeMarketsSlice.reducer;
